import {Component, Input, OnInit} from '@angular/core';
import {TranslateContext} from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-general-stepper',
	templateUrl: './general-stepper.component.html',
	styleUrls: ['./general-stepper.component.scss']
})
export class GeneralStepperComponent implements OnInit {
	@Input() stepper_title: string;
	@Input() show_title: boolean;
	@Input() status: any;
	@Input() icon: string;
	@Input() min_width: string = '130px';
	@Input() translate_context: TranslateContext;
	@Input() step_list: GeneralStep[];

	constructor() {
	}

	ngOnInit(): void {
	}
}

export interface GeneralStep {
	name: string;
	done_icon?: string;
	todo_icon?: string;
	description?: string;
	done: boolean;
	has_title_index?: boolean;
	is_active?: boolean;
}
